import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import {BACKEND_ENDPOINT} from "../const/appConst";

const LogoutButton = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        const userId = localStorage.getItem("userId");

        try {
            await axios.post(`${BACKEND_ENDPOINT}/auth/logout`, { userId });

            // Clear local storage
            localStorage.removeItem("userId");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("isAuthenticated");
            localStorage.removeItem("userPicture");

            // Redirect to login page or show a message
            navigate("/login");
        } catch (error) {
            console.error("Error logging out:", error);
        }
    };

    return (
        <button onClick={handleLogout} className="btn btn-primary">
           Logout
        </button>
    );
};

export default LogoutButton;